
import cryptoRandomString from 'crypto-random-string'

export default {
  data() {
    return {
      qrCodeImgUrl: '', // 验证码请求地址
      code: '', // 验证码随机数
      imageCheckCode: '',
    }
  },
  methods: {
    reGetQrCodeHandle() {
      this.getQrImg()
    },

    async getQrImg() {
      this.code = cryptoRandomString({length: 10})
      this.qrCodeImgUrl = `http://cloud.changanfoundation.com/api/v1/configs/get-image-code?code=${this.code}`
    }
  },
  created() {
    this.getQrImg()
  }
}
